/** "1 gate", "3 gates": a count with its noun, plural unless the count is 1. */
export function plural(n: number, noun: string): string {
  return `${n} ${noun}${n === 1 ? '' : 's'}`;
}
